'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Layer = require('./Layer');

var _Layer2 = _interopRequireDefault(_Layer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LayerTransitionChild = function (_React$Component) {
  _inherits(LayerTransitionChild, _React$Component);

  function LayerTransitionChild() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LayerTransitionChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LayerTransitionChild.__proto__ || Object.getPrototypeOf(LayerTransitionChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      stage: 'entering'
    }, _this._onAnimationEnd = function () {
      var stage = _this.state.stage;

      if (stage === 'show' && _this._enterCallback) {
        _this._enterCallback();
        _this._enterCallback = null;
        // This else is important - the above `this._enterCallback()` will continue
        // execution here after `componentWillLeave`
      } else if (stage === 'exiting' && _this._exitCallback) {
        _this._exitCallback();
        _this._exitCallback = null;
        _this.props.onExit && _this.props.onExit();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LayerTransitionChild, [{
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.componentWillEnter(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.setState({
        stage: 'show'
      });
      this._enterCallback = callback;
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.componentDidEnter();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      if (this.state.stage === 'exiting') {
        return;
      }
      this.setState({
        stage: 'shown'
      });
      this.props.onEnter && this.props.onEnter();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this._enterCallback = null;
      this.setState({
        stage: 'exiting'
      });
      this._exitCallback = callback;
    }
  }, {
    key: 'render',
    value: function render() {
      var stage = this.state.stage;

      var _props = this.props,
          enterFrame = _props.enterFrame,
          frame = _props.frame,
          exitFrame = _props.exitFrame,
          enterStyle = _props.enterStyle,
          style = _props.style,
          exitStyle = _props.exitStyle,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          props = _objectWithoutProperties(_props, ['enterFrame', 'frame', 'exitFrame', 'enterStyle', 'style', 'exitStyle', 'onEnter', 'onExit']);

      var f = frame;
      var s = style;
      switch (stage) {
        case 'entering':
          if (enterFrame) {
            f = Object.assign({}, f, enterFrame);
          }
          if (enterStyle) {
            s = Object.assign({}, s, enterStyle);
          }
          break;
        case 'exiting':
          if (exitFrame) {
            f = Object.assign({}, f, exitFrame);
          }
          if (exitStyle) {
            s = Object.assign({}, s, exitStyle);
          }
          break;
        case 'show':
        case 'shown':
          break;
        default:
          throw new Error('unexpected case');
      }
      return _react2.default.createElement(_Layer2.default, Object.assign({}, props, {
        frame: f,
        style: s,
        onAnimationEnd: this._onAnimationEnd
      }));
    }
  }]);

  return LayerTransitionChild;
}(_react2.default.Component);

exports.default = LayerTransitionChild;


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/LayerTransitionChild.js
// module id = 169
// module chunks = 0